import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { LogisticPivotApiAdapter } from '../adapters/LogisticPivotApiAdapter';
import type { LogisticPivotData, LogisticPivotQuery } from '../models/LogisticPivot';

interface UseLogisticPivotDataProps {
  query?: LogisticPivotQuery;
}

export const useLogisticPivotData = ({ query }: UseLogisticPivotDataProps = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new LogisticPivotApiAdapter(httpClient);

  const stableKey = query ? JSON.stringify(query) : '{}';

  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<LogisticPivotData>({
    queryKey: ['logisticPivotReport', stableKey],
    queryFn: () => adapter.getLogisticPivot(query),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return {
    rows: data?.rows ?? [],
    filtersEcho: data?.filters,
    isLoading,
    isFetching,
    error: error instanceof Error ? error.message : error ? String(error) : null,
    refetch,
  };
};
